import {
    CommercialTypeTag, GovernmentalTypeTag, IndustrialTypeTag,
    OtherTypeTag,
    ResidentialTypeTag,
    ServiceTypeTag
} from "../components/ui-kit/tags/type-of-use-tag";
import {
    BookedStatusTag,
    OccupiedStatusTag,
    OtherStatusTag, RentedStatusTag,
    VacantStatusTag
} from "../components/ui-kit/tags/status-tag";

export const renderStatusTag = (status: string, className?: string) => {
    switch (status) {
        case "Vacant":
            return <VacantStatusTag className={className} />;
        case "Occupied":
            return <OccupiedStatusTag className={className} />;
        case "Booked":
            return <BookedStatusTag className={className} />;
        case "Rented":
            return <RentedStatusTag className={className} />;
        default:
            return <OtherStatusTag text={status} className={className} />;
    }
};

export const renderTypeOfUseTag = (typeOfUse: string, className?: string) => {
    switch (typeOfUse) {
        case "Industrial":
            return <IndustrialTypeTag className={className}/>;
        case "Residential":
            return <ResidentialTypeTag className={className}/>;
        case "Service":
            return <ServiceTypeTag className={className}/>;
        case "Commercial":
            return <CommercialTypeTag className={className}/>;
        case "Governmental":
            return <GovernmentalTypeTag className={className}/>;
        default:
            return <OtherTypeTag text={typeOfUse} className={className}/>;
    }
};